const MailIcon = () => {
  return (
    <g id='sms'>
      <path
        id='Vector'
        d='M16.6875 19.9688H7.3125C4.5 19.9688 2.625 18.5625 2.625 15.2812V8.71875C2.625 5.4375 4.5 4.03125 7.3125 4.03125H16.6875C19.5 4.03125 21.375 5.4375 21.375 8.71875V15.2812C21.375 18.5625 19.5 19.9688 16.6875 19.9688Z'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_2'
        d='M16.6875 9.1875L13.7531 11.5313C12.7875 12.3 11.2031 12.3 10.2375 11.5313L7.3125 9.1875'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  );
};

export default MailIcon;
